import { render } from "./taskTemplates.vue?vue&type=template&id=6884f3cc&scoped=true"
import script from "./taskTemplates.vue?vue&type=script&lang=js"
export * from "./taskTemplates.vue?vue&type=script&lang=js"

import "./taskTemplates.vue?vue&type=style&index=0&id=6884f3cc&lang=scss&scoped=true"

import exportComponent from "/home/jenkins-prod/worker1/workspace/jaka-digital/A-01-OTA/jaka-ota-admin-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6884f3cc"]])

export default __exports__